import React, { useContext, useState } from 'react'
import Images from '../../../assets/Images'
import { Tooltip } from 'react-tooltip'
import constant from '../../../constants/constant';
import { findConstantLabel, priceTagFormatter, renderOptions } from '../../../constants/utils'
import atoms from '../../atoms'
import service from '../../../api/services';
import { useToasts } from 'react-toast-notifications';
import { useNavigate } from 'react-router';
import { SalesCartTimer } from '../../../Context';
import { yellow } from '@mui/material/colors';
import { setShouldRefetch } from "../../../features/productList/list/shouldRefetchListSlice";
import { useDispatch } from 'react-redux';


const { Button } = atoms
const { Copy } = Images
const Index = ({ productDetails, _handleProductId, title }: any) => {
    const { addToast } = useToasts();
    const navigate = useNavigate()
    const dispatch = useDispatch()
    let filterPath = localStorage.getItem("product_filter") || constant.PRODUCT_FILTER_TYPE.DEFAULT;
    const productData = productDetails
    const colors = productDetails?.extra_details?.variants;
    const periodUse = productDetails?.extra_details?.period_use
    const packOfQuantity = productDetails?.extra_details?.pack_of_quantity
    const glassSize = productDetails?.extra_details?.glass_sizes
    const { salesCartTimer, setSalesCartTimer }: any = useContext(SalesCartTimer)

    // INFO:- do not remove this code
    // const coloredDivs = colors && colors.map((color: any, index: number) => {
    //     if (color.specx_colors.length === 2) {
    //         // Handle the case where there are two colors
    //         const [color1, color2] = color.specx_colors;
    //         return (
    //             <div className={color?.brand_color_code == productDetails?.brand_color_code ? 'p-1 active-border-color rounded-circle' : 'p-1 border border-white rounded-circle'}
    //                 onClick={() => { _handleProductId(color.product_id) }}>
    //                 <div key={`color${index}`} className="diagonal-color-div cursor-pointer"
    //                     data-tooltip-id={`color${index}`}
    //                     // data-tooltip-content={color.brand_color_name color.brand.color_code}
    //                     data-tooltip-content={`${color.brand_color_name}, ${color.brand_color_code}`}

    //                 >
    //                     {/* <div className={
    //                     selectColor==index ? 'p-1 border border-primary rounded-circle' : ''}>
    //                 </div> */}
    //                     <div
    //                         // className="half-color"
    //                         className="diagonal-color-div cursor-pointer rounded-circle"
    //                         style={{ backgroundColor: color1.color_code }}
    //                     ></div>
    //                     {/* <div
    //                     className="half-color"
    //                     style={{ backgroundColor: color2.color_code }}
    //                 ></div> */}
    //                     <Tooltip id={`color${index}`} />
    //                 </div>
    //             </div>
    //         );
    //     } else if (color.specx_colors.length === 1) {
    //         // Handle the case where there is only one color
    //         const singleColor = color.specx_colors[0];
    //         return (
    //             <div className={
    //                 (color?.brand_color_code == productDetails?.brand_color_code) ? 'p-1 active-border-color rounded-circle' : 'p-1 border border-white rounded-circle'}
    //                 onClick={() => { _handleProductId(color.product_id) }}>
    //                 <div key={`color${index}`}
    //                     style={{ backgroundColor: singleColor.color_code }}
    //                     className="color-div cursor-pointer"
    //                     data-tooltip-id={`color${index}`}
    //                     // data-tooltip-content={color.brand_color_name}
    //                     data-tooltip-content={`${color.brand_color_name}, ${color.brand_color_code}`}>
    //                     <Tooltip id={`color${index}`} />
    //                 </div>
    //             </div>

    //         );
    //     } else {
    //         return null; // Handle other cases or add error handling as needed
    //     }
    // });
    // end

    const coloredDivs = colors && colors.map((color: any, index: number) => {
        if (color?.specx_colors && color?.specx_colors?.length > 0) {
            // Handle the case where there is only one color
            const singleColor = productData?.is_contact_lens ? color : color.specx_colors[0];
            return (
                <div className={
                    (color?.brand_color_code == productDetails?.brand_color_code) ? 'p-1 active-border-color rounded-circle' : 'p-1 border border-white rounded-circle'}
                    onClick={() => { _handleProductId(color.product_id) }}>
                    <div key={`color${index}`}
                        style={{ backgroundColor: singleColor?.color_code }}
                        className="color-div cursor-pointer"
                        data-tooltip-id={`color${index}`}
                        // data-tooltip-content={color.brand_color_name}
                        data-tooltip-content={`${color.brand_color_name}, ${color.brand_color_code}`}>
                        <Tooltip id={`color${index}`} />
                    </div>
                </div>

            );
        } else {
            return null; // Handle other cases or add error handling as needed
        }
    });

    const coloredContactLensDivs = colors && colors?.map((color: any, index: number) => {
        if (productData?.is_contact_lens) {
            const singleColor = color
            return (
                <div className={
                    (color?.color_code === productData?.color?.color_code) ? 'p-1 active-border-color rounded-circle' : 'p-1 border border-white rounded-circle'}
                    onClick={() => { _handleProductId(color.product_id) }}>
                    <div key={`color${index}`}
                        style={{ backgroundColor: singleColor?.color_code }}
                        className="color-div cursor-pointer"
                        data-tooltip-id={`color${index}`}
                        data-tooltip-content={`${color.color_name}, ${color.color_code}`}>
                        <Tooltip id={`color${index}`} />
                    </div>
                </div>

            );
        } else {
            return null;
        }
    });

    const manageMultiplePeriod = renderOptions(
        periodUse,
        productDetails?.period_use,
        "period_use",
        _handleProductId, true
    );

    const manageMultipleQuantity = renderOptions(
        packOfQuantity,
        productDetails?.pack_of_quantity,
        "pack_of_quantity",
        _handleProductId, false
    );
    const manageMultipleGlassSize = renderOptions(
        glassSize,
        productDetails?.glass_size,
        "glass_size",
        _handleProductId, false
    );

    const productWarranty = constant.PRODUCT_WARRANTY.find(warranty => warranty.value === productData?.warranty);

    const _handleAddToCart = async (productID: string) => {
        try {
            const payload = {
                product_id: productID
            }
            const response = await service.SalesCart.addToCart(payload)
            if (response.status === 200) {
                // For re-fetching the stock API
                dispatch(setShouldRefetch(true))
                // end
                navigate(`/product/list?${filterPath}`)
                setSalesCartTimer({ isFirst: false, isStarted: !salesCartTimer.isStarted })
                localStorage.setItem('sales_count', '1')
                localStorage.setItem('salesCartTimerPopup', '1')
                addToast(response?.data?.message, {
                    appearance: 'success',
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
            }
        } catch (error: any) {
            addToast(error?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
            console.log(error);
        }
    }
    return (
        <>
            <div className="row mt-sm-4 mt-1">
                <div className="col-md-8 mt-md-4 mt-md-3 order-2 order-md-1">
                    <h2 className='mb-0 fs-md-20 fs-14 fw-600'>{productData?.brand?.brand_name}</h2>
                    <div className='d-flex d-md-none mt-1'>
                        <h2 className='mb-0 fs-md-20 fs-14 fw-600'>Model No :</h2>
                        <h2 className='mb-0 fs-md-20 fs-14 fw-400 ms-1'>{productData?.modal_number}</h2>
                    </div>
                    <h2 className='mb-0 fs-md-24 fs-14 fw-700 mt-1'>{title?.toUpperCase()}</h2>
                    <h2 className='mb-0 fs-md-24 fs-16 fw-600 mt-3'>{priceTagFormatter(productData?.product_srp)}</h2>
                </div>

                <div className="d-none d-lg-block col-md-4 mt-4 mt-md-3 order-1 order-md-2">
                    <div className='row'>
                        <div className='col-4 d-flex align-items-center'>
                            <h2 className='mb-md-0 mb-1 fs-16 fw-600' style={{ minWidth: "150px" }}>Product ID :-</h2>
                        </div>
                        <div className='col-8 id-input-design d-flex justify-content-between align-items-center gap-2 w-60'>
                            <h2 className='mb-0 fs-md-16 fw-400'>{productData?.product_id_display}</h2>
                            <img src={Copy} alt="" className='img-fluid' style={{ width: "18px" }} />
                        </div>
                    </div>
                    {(productData?.sku_numbers?.length > 0) && <div className='row mt-2'>
                        <div className='col-4'>
                            <h2 className='mb-md-0 mb-1 fs-16 fw-600'>SKU :-</h2>
                        </div>
                        <div className='col-8'>
                            {productData?.sku_numbers &&
                                (Array.from(new Set(productData.sku_numbers)) as string[]).map((item: string, index: number) => {
                                    return (
                                        <span className='mb-0 fs-md-16 fw-400' key={index}>
                                            {`${item}${index < ((Array.from(new Set(productData.sku_numbers)) as string[]).length - 1) ? "," : ""}`}
                                        </span>
                                    );
                                })
                            }
                        </div>
                    </div>}
                </div>
            </div>

            {productData?.is_contact_lens ? <div className='d-flex gap-3 mt-sm-3 mt-2'>
                <h2 className='my-auto fs-md-18 fs-12 fw-600' style={{ minWidth: "7vw" }}>Period use :</h2>
                <div className='d-flex gap-2' style={{ flexWrap: "wrap" }}>
                    {manageMultiplePeriod}
                </div>

            </div > :
                <div className='d-flex gap-3 mt-sm-3 mt-2'>
                    <h2 className='my-auto fs-md-18 fs-12 fw-600' style={{ minWidth: "7vw" }}>Product Color :</h2>
                    <div className='d-flex gap-2' style={{ flexWrap: "wrap" }}>
                        {coloredDivs}
                    </div>

                </div >

            }
            {productData?.is_contact_lens ?
                <div className='d-flex gap-3 mt-sm-3 mt-2'>
                    <h2 className='my-auto fs-md-18 fs-12 fw-600' style={{ minWidth: "7vw" }}>Pack of :</h2>
                    <div className='d-flex gap-2' style={{ flexWrap: "wrap" }}>
                        {manageMultipleQuantity}
                    </div>

                </div>
                : <div className='d-flex align-items-center gap-3 mt-md-4 mt-2'>
                    <h2 className='fs-md-18 fs-12 fw-700 my-auto'>Glass Size/Power :</h2>
                    <div className='d-flex gap-2'>
                        {manageMultipleGlassSize}
                    </div>
                </div>}
            <div>

            </div>



            {productData?.is_contact_lens ? <div className='d-flex gap-3 mt-sm-3 mt-2'>
                <h2 className='my-auto fs-md-18 fs-12 fw-600' style={{ minWidth: "7vw" }}>Color :</h2>
                <div className='d-flex gap-2' style={{ flexWrap: "wrap" }}>
                    {coloredContactLensDivs}
                </div>

            </div> : productData?.isPolarised !== constant.POLARIZED[2].value && <div className='d-flex align-items-center gap-3 mt-sm-4 mt-3'>
                <h2 className='mb-0 fs-md-18 fs-12 fw-700'>Polarized</h2>
                {productDetails?.extra_details?.polarized?.map((item: any, index: number) => {
                    return (
                        <>
                            {item?.isPolarised == constant.POLARIZED[0].value && <div className='d-flex gap-2'>
                                <label>
                                    <input type="radio" name="polarized1" value={1} onChange={() => _handleProductId(item?.isPolarised == constant.POLARIZED[0].value && item.product_id)}
                                        checked={productData?.isPolarised === constant.POLARIZED[0].value} />
                                    <span
                                        className={!productDetails?.extra_details?.polarized[0] ? 'fs-md-18 fs-12 fw-500 text-secondary' : 'fs-md-18 fs-12 fw-500'}
                                    > Yes</span>
                                </label>
                            </div>}
                            {item?.isPolarised == constant.POLARIZED[1].value && <div className='d-flex gap-2'>
                                <label>
                                    <input type="radio" name="polarized1" value={2}
                                        onChange={() => _handleProductId(item?.isPolarised == constant.POLARIZED[1].value && item.product_id)}
                                        checked={productData?.isPolarised === constant.POLARIZED[1].value}
                                    />
                                    <span
                                        className={productDetails?.extra_details?.polarized[0] == 2 ?
                                            'fs-md-18 fs-12 fw-500 text-secondary' : 'fs-md-18 fs-12 fw-500'}
                                    > No</span>
                                </label>
                            </div>}
                        </>
                    )
                })}
            </div>}

            {!productData?.is_contact_lens && <div className="row align-items-center">
                <div className='col-lg-6 row'>
                    <div className="col-6 mt-sm-3 mt-2">
                        <div className="d-flex flex-wrap align-items-center gap-3 ">
                            <h2 className='mb-0 fs-md-18 fs-12 fw-600'>Bridge Size :</h2>
                            <span className='fs-md-18 fs-12 fw-400'>{productData?.bridge_size}</span>
                        </div>
                    </div>
                    <div className="col-6 mt-sm-3 mt-2">
                        <div className="d-flex flex-wrap align-items-center gap-3 ">
                            <h2 className='mb-0 fs-md-18 fs-12 fw-600'>Temple Size :</h2>
                            <span className='fs-md-18 fs-12 fw-400'>{productData?.temple_size}</span>
                        </div>
                    </div>
                </div>
                <div className='col-lg-6 row remove-padding-right'>
                    <div className="col-6 mt-sm-3 mt-2">
                        <div className="d-flex flex-wrap align-items-center gap-lg-3 gap-1 ">
                            <h2 className='mb-0 fs-md-18 fs-12 fw-600'>Lense Color  :</h2>
                            {productData?.lens_colors?.map((item: any, index: number) => {
                                return (
                                    <div key={`color${index}`}
                                        className="color-div "
                                        style={{ backgroundColor: item.color_code, borderRadius: '0px' }}>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div className="col-6 ps-md-0 mt-sm-3 mt-2">
                        <div className="d-flex flex-wrap align-items-center gap-lg-3 gap-1">
                            <h2 className='mb-0 fs-md-18 fs-12 fw-600'>Warranty :</h2>
                            <span className='fs-md-18 fs-12 fw-400'>
                                {productWarranty ? productWarranty.label : "Na"}
                            </span>
                        </div>
                    </div>
                </div>

            </div>
            }
            {!productData?.is_contact_lens && <div className="row align-items-center">
                <div className="col-6 mt-sm-3 row">
                    <div className="d-flex flex-wrap align-items-center gap-lg-3 gap-1 ">
                        <h2 className='mb-0 fs-md-18 fs-12 fw-600'>Product with case :</h2>
                        <span className='fs-md-18 fs-12 fw-400'>{productData?.product_with_case ? 'Yes' : 'No'}</span>
                    </div>
                </div>
                <div className="col-6 mt-sm-3 mt-1 ps-4 ps-md-2 ps-lg-3">
                    <div className="d-flex gap-lg-3 flex-wrap align-items-center">
                        <h2 className='mb-0 fs-md-18 fs-12 fw-600 gap-lg-3'>Features :</h2>
                        {productData?.features && productData?.features?.map((item: any, index: number) => {
                            return (
                                <span className='fs-md-18 fs-12 fw-400'
                                >{`${findConstantLabel(constant.PRODUCT_FEATURES, item)}${index < (productData?.features?.length - 1) ? "," : ""}`}</span>
                            )
                        })}
                    </div>
                </div>
            </div>
            }
            <div className="row my-md-4 my-2">
                <div className="col">
                    <div className="d-block align-items-center gap-3 ">
                        <h2 className='mb-0 fs-md-20 fs-14 fw-600 mb-md-3'>Product Description :</h2>
                        <span className='fs-md-18 fs-12 fw-500 '>{productData?.description?.toUpperCase()}</span>
                    </div>

                </div>
            </div>
            <div className="row my-md-4 mb-2">
                <div className="col">
                    <Button name={'Add To Cart'}
                        onClick={() => _handleAddToCart(productData?.id)}
                        className={`w-100 fw-700 fs-md-18 fs-12`} />
                </div>
            </div>
        </>
    )
}

export default Index